module.exports = __webpack_public_path__ + "img/er.er4e8d72f.svg";